// @flow
import * as React from 'react';
import cn from 'classnames';
import Picker from 'react-mobile-picker';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

// Components
import Modal from 'components/atoms/Modal';
import Button from 'components/atoms/Button';
import { Icon } from 'components/atoms/Icon';

import './MobileDropdown.scss';

const ns = 'mobile-dropdown';

type Props = {
  value: string,
  options: Array<string>,
  icon?: string,
  placeholder?: string,
  onChange: (value: string) => void,
  intl: IntlShape,
  className?: string
};
type State = {
  showModalPicker: boolean,
  usePlaceholder: boolean,
  valueGroups: Object,
  optionGroups: Object
};

class MobileDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showModalPicker: false,
      valueGroups: { value: props.value },
      optionGroups: { value: props.options },
      usePlaceholder: props.value === ''
    };
    (this: any).modalPicker = React.createRef();
    (this: any).toggleModal = this.toggleModal.bind(this);
  }

  modalPicker: React.Ref<any>;

  toggleModal = (show: boolean = true) => {
    (this: any).modalPicker.current.setShowModal(show);
    this.setState({
      showModalPicker: show,
      usePlaceholder: false
    });
  };

  handleChange = (name: string, value: string) => {
    const { onChange } = this.props;
    const { usePlaceholder } = this.state;
    if (!usePlaceholder) {
      onChange(value);
      this.setState({
        valueGroups: { [name]: value }
      });
    }
  };

  getModalHeader = () => {
    const { intl } = this.props;
    return (
      <div className={`${ns}__header`}>
        <Button
          buttonTheme={'link'}
          className={`${ns}__button--right`}
          onClick={() => this.toggleModal(false)}
        >
          {intl.formatMessage({
            id: 'c8.self.check.in.common.done',
            defaultMessage: 'Done'
          })}
        </Button>
      </div>
    );
  };

  render() {
    const { icon, placeholder, className } = this.props;
    const { optionGroups, valueGroups } = this.state;
    const label = valueGroups.value || placeholder;
    const labelClassName = cn(`${ns}__label`, {
      [`${ns}__label--placeholder`]: !valueGroups.value
    });
    const dropdownClassName = cn(ns, className);
    return (
      <div className={dropdownClassName}>
        <div className={`${ns}__input`} onClick={() => this.toggleModal(true)}>
          {icon && <Icon type={icon} className={`${ns}__icon`} />}
          <div className={labelClassName}>{label}</div>
        </div>
        <Modal
          ref={this.modalPicker}
          showCloseButton={false}
          className={`${ns}__modal`}
          size={'mobile-picker'}
          header={() => this.getModalHeader()}
        >
          <Picker
            optionGroups={optionGroups}
            valueGroups={valueGroups}
            onChange={this.handleChange}
          />
        </Modal>
      </div>
    );
  }
}

export default injectIntl(MobileDropdown);



// WEBPACK FOOTER //
// ./src/components/molecules/MobileDropdown/MobileDropdown.js